(function() {
    function equalizeRowHeights() {
        var products = document.querySelectorAll('.ns-product');
        var titles = document.querySelectorAll('.ns-product-title');
        if (titles.length === 0) return;
        titles.forEach(function(el) { el.style.minHeight = ''; });
        void document.body.offsetHeight;
        var rows = {};
        products.forEach(function(product, i) {
            var top = product.offsetTop;
            if (!rows[top]) rows[top] = [];
            if (titles[i]) rows[top].push(titles[i]);
        });
        Object.values(rows).forEach(function(rowTitles) {
            var maxHeight = Math.max.apply(null, rowTitles.map(function(el) { return el.offsetHeight; }));
            rowTitles.forEach(function(el) { el.style.minHeight = maxHeight + 'px'; });
        });
    }
    var timeout;
    function debouncedEqualize() {
        clearTimeout(timeout);
        timeout = setTimeout(equalizeRowHeights, 50);
    }
    var observer = new MutationObserver(debouncedEqualize);
    function start() {
        observer.observe(document.body, { childList: true, subtree: true });
        debouncedEqualize();
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
    } else {
        start();
    }
    window.addEventListener('resize', debouncedEqualize);
})();
